import React from "react";
import { navigate } from "src/utils/react-utils";
import { getLibraryURL } from "../utils/get-simulation-library-url";
import Button from "./button";

export default function SimplifierToolHeader({simplifiedData,showEditor,title,setShowEditor}) {
    const doNavigation = () => {
        if(showEditor){
            navigate('/my-reviews');
        }else{
            setShowEditor(true);
        }
    }
    function gotoLibrary(){
      //@ts-ignore
      history.push( getLibraryURL({engagement_id:simplifiedData?.engagement?._id,review_id:simplifiedData?.review?._id}))
    }

    return (
        <div css={`display:flex;`}>
          <div css={`flex-grow:1;`}>

              <div css={`
                  font-size:24px;
                  color:#2E2E38;
              `}>
                  {props.title}
              </div>
              <div>
                  <span css={`
                      color:#799fd4;
                      cursor: pointer;
                      text-decoration-line: underline;
                  `}
                  onClick={() => {doNavigation()}}>{showEditor ? '← Back to my review':'← Back to simplifier'}</span>
              </div> 
          </div>
          <div>
              <Button 
                onClick={gotoLibrary}>
                  Go to simulations
              </Button>
          </div>
        </div>
    )

}